import React from 'react'

export default class SettingsTitle extends React.Component {
    constructor(props){
        super(props)
    }

    render(){
        return(
            <h4 style={subtitle}>{this.props.title}</h4>
        )
    }
};

const subtitle = {
    fontSize: 17,
    fontWeight: 'bold',
    margin: 0
}